import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import emojiFlags from 'emoji-flags';
import emoji from '/components/emoji';
import ItineraryMap from '../Destinations/ItineraryMap';
import CardActionArea from '@mui/material/CardActionArea';
import Link from 'next/link';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function ItinerariesList({ initialItineraries }) {
  const isScreenLg = useMediaQuery('(min-width: 576px)');
  const isScreenXl = useMediaQuery('(min-width: 1200px)');

  return (
    <>
      {initialItineraries.map(itinerary => {
        return (
          <div key={itinerary.title} className="mt-2">
            <Card>
              <CardContent>
                <h5 className="tw-mb-0">
                  {emoji(
                    emojiFlags.countryCode(itinerary.countryCode.toUpperCase())
                      .emoji,
                  )}{' '}
                  {itinerary.title}{' '}
                  <div className="tw-break-inside-avoid tw-inline-block">
                    (
                    {itinerary.duration % 7 === 0
                      ? `${itinerary.duration / 7} week${
                          itinerary.duration === 7 ? '' : 's'
                        }`
                      : `${itinerary.duration} days`}
                    )
                  </div>
                </h5>
                {/* <Itinerary itinerary={itinerary} noLinks hideTitle /> */}
              </CardContent>
              <Link
                href={`/@${itinerary.author.username}/itineraries/${itinerary.permlink}`}
              >
                <CardActionArea className="h-100">
                  <div className="tw-h-[23.7rem] tw-relative">
                    <ItineraryMap
                      rounding={0}
                      width={isScreenXl ? 840 : isScreenLg ? 650 : 400}
                      itinerary={itinerary}
                      locationDetails={{ countryCode: itinerary.countryCode }}
                    />
                  </div>
                </CardActionArea>
              </Link>
            </Card>
          </div>
        );
      })}
    </>
  );
}
